import { useMemo } from 'react';

import { DEFAULT_PAGE_SIZE } from 'consts';
import { useApiAccess } from 'contexts/AccessProvider';
import { useListSubmitGatewayEventsTaskQuery } from 'gql';
import { usePagination, useSortBy } from 'hooks';
import { SubmitTaskColumns } from 'pages/GMP/GMPList/components/SubmitTaskColumn';
import { useNavigate, useParams } from 'react-router-dom';

export const useTaskData = () => {
  const { sessionKey } = useApiAccess();
  const navigate = useNavigate();
  const { id } = useParams();

  const {
    PageController: SubmitGatewayEventPageController,
    setTotalDataCount: setTotalSubmitGatewayEventDataCount,
    pageSize: submitGatewayEventPageSize,
    pageNumber: submitGatewayEventPageNumber,
  } = usePagination({
    defaultPageSize: DEFAULT_PAGE_SIZE,
    shouldUpdateUrl: true,
  });

  const { sortField, sortOrder, onSort } = useSortBy();

  const { data: SubmitGatewayEventData, loading: submitGatewayEventLoading } =
    useListSubmitGatewayEventsTaskQuery({
      variables: {
        sessionKey,
        page: { size: submitGatewayEventPageSize, number: submitGatewayEventPageNumber },
        ...(sortField && {
          sort: { field: sortField, order: sortOrder },
        }),
        shardId: parseInt(id as string),
      },
      onCompleted(data) {
        setTotalSubmitGatewayEventDataCount(data.listSubmitGatewayEventsTask.count);
      },
      fetchPolicy: 'cache-and-network',
    });

  const sumbitGateWayColumn = SubmitTaskColumns({ navigate });

  const [pageSize, PageController] = useMemo(
    () => [submitGatewayEventPageSize, SubmitGatewayEventPageController],
    [submitGatewayEventPageSize, SubmitGatewayEventPageController]
  );

  return {
    tasksDataCount: SubmitGatewayEventData?.listSubmitGatewayEventsTask.count,
    submitGatewayEventLoading,
    sortOrder,
    onSort,
    sumbitGateWayColumn,
    SubmitGatewayEventData,
    pageSize,
    PageController,
  };
};
